var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcInterview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.95 51.892 1.203 9.744c.308 2.559-2.436 4.347-4.625 3.021l-12.92-7.677c-1.418 0-2.805-.092-4.162-.277 2.282-2.683 3.639-6.075 3.639-9.744 0-8.757-7.586-15.848-16.959-15.848-3.577 0-6.876 1.017-9.62 2.806a19.544 19.544 0 0 1-.123-2.344c0-14.029 12.179-25.406 27.226-25.406 15.046 0 27.226 11.377 27.226 25.406 0 8.325-4.286 15.694-10.885 20.32z",
    stroke: "#00EDD5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.083 46.96c0 3.669-1.357 7.06-3.639 9.743-3.052 3.7-7.893 6.074-13.32 6.074l-8.047 4.779c-1.357.832-3.084-.308-2.899-1.88l.771-6.075C8.818 56.734 6.166 52.14 6.166 46.96c0-5.426 2.898-10.205 7.338-13.042 2.745-1.788 6.044-2.806 9.62-2.806 9.374 0 16.959 7.092 16.959 15.848z",
    stroke: "#00EDD5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcInterview);
export default __webpack_public_path__ + "static/media/CCInterview.f569d6c3529bdbfa036eec002e80c8ba.svg";
export { ForwardRef as ReactComponent };